module.exports = __webpack_public_path__ + "img/工作區域 3.png";